var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import AnalysisStudyLogPerformanceConstants from "./AnalysisStudyLogPerformanceConstants.js";
const getDefaultState = () => {
  return {
    loadStartTimeInMs: 0,
    loadStartAction: null,
    stepMetadataMainFunctionalityPerfEntry: null,
    forayConfigMainFunctionalityPerfEntry: null,
    studyAbstractsV2MainFunctionalityPerfEntry: null,
    studyAbstractV2MainFunctionalityPerfEntry: null,
    studyTaskV2MainFunctionalityPerfEntry: null,
    mainFunctionality: null
  };
};
const loadStart = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    loadStartTimeInMs: actionResult.payload.clientTimeInMs,
    loadStartAction: actionResult.type,
    // reset all timings on LoadStart
    stepMetadataMainFunctionalityPerfEntry: null,
    forayConfigMainFunctionalityPerfEntry: null,
    studyAbstractsV2MainFunctionalityPerfEntry: null,
    studyAbstractV2MainFunctionalityPerfEntry: null,
    studyTaskV2MainFunctionalityPerfEntry: null,
    mainFunctionality: null
  });
};
const mainFunctionality = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    mainFunctionality: {
      timeSinceLoadStartInMs: actionResult.payload.timeSinceLoadStartInMs,
      lastPartToLoad: actionResult.payload.lastPartToLoad
    }
  });
};
const AnalysisStudyLogPerformanceReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case AnalysisStudyLogPerformanceConstants.LOAD_START:
    case AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_LIST:
    case AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY:
    case AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_TASK:
      return loadStart(state, actionResult);
    case AnalysisStudyLogPerformanceConstants.STEP_METADATA_MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        stepMetadataMainFunctionalityPerfEntry: actionResult.payload
      });
    case AnalysisStudyLogPerformanceConstants.FORAY_METADATA_MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        forayConfigMainFunctionalityPerfEntry: actionResult.payload
      });
    case AnalysisStudyLogPerformanceConstants.STUDY_ABSTRACTS_V2_MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        studyAbstractsV2MainFunctionalityPerfEntry: actionResult.payload
      });
    case AnalysisStudyLogPerformanceConstants.STUDY_ABSTRACT_V2_MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        studyAbstractV2MainFunctionalityPerfEntry: actionResult.payload
      });
    case AnalysisStudyLogPerformanceConstants.STUDY_TASK_V2_MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        studyTaskV2MainFunctionalityPerfEntry: actionResult.payload
      });
    case AnalysisStudyLogPerformanceConstants.MAIN_FUNCTIONALITY:
      return mainFunctionality(state, actionResult);
    default:
      return state;
  }
};
export {
  AnalysisStudyLogPerformanceReducer,
  AnalysisStudyLogPerformanceReducer as default,
  getDefaultState
};
//# sourceMappingURL=AnalysisStudyLogPerformanceReducer.js.map
